/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import { Button, Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { swapTeamIdBetween2Players, changePlayerTeam } from 'redux/slices';

export function SwapPlayersBtn() {
  const players = useSelector((state) => state.players);
  const genderBalanceMode = useSelector((state) => state.game.genderBalanceMode);
  const genderRestrictedMode = useSelector((state) => state.game.genderRestrictedMode);
  const setterRestrictedMode = useSelector((state) => state.game.setterRestrictedMode);
  const dispatch = useDispatch();

  const handlePlayerChangeTeam = (playerId1, playerId2) => {
    dispatch(changePlayerTeam({ playerId1, playerId2 }));
    dispatch(swapTeamIdBetween2Players({ playerId1, playerId2 }));
  };

  const swapPlayers = () => {
    const originalTeamA = players.filter((player) => player.teamId === 1);
    const originalTeamB = players.filter((player) => player.teamId === 2);

    const teamASetters = originalTeamA.filter((p) => p.playerType === 'Setter');
    const teamBSetters = originalTeamB.filter((p) => p.playerType === 'Setter');
    const totalSetters = teamASetters.length + teamBSetters.length;
    const teamAFemales = originalTeamA.filter((p) => p.gender === 'F').length;
    const teamBFemales = originalTeamB.filter((p) => p.gender === 'F').length;
    const totalFemales = teamAFemales + teamBFemales;
    const hasSingleFemale = genderRestrictedMode && totalFemales === 1;
    const isOddFemales = hasSingleFemale || (!genderRestrictedMode && totalFemales % 2 === 1);

    const getPlayerPoints = (p) => p.totalPoints ?? (p.wins - p.losses);
    const calculateTeamScore = (team) => team.reduce((total, player) => total + getPlayerPoints(player), 0);
    const teamAScore = calculateTeamScore(originalTeamA);
    const teamBScore = calculateTeamScore(originalTeamB);

    let playerToSwapFromA = null;
    let playerToSwapFromB = null;

    if (teamASetters.length >= 2 && teamBSetters.length === 0) {
      const setterToMove = teamASetters[teamASetters.length - 1];
      const nonSettersTeamB = originalTeamB.filter((p) => p.playerType !== 'Setter');
      const validCandidates = genderBalanceMode
        ? nonSettersTeamB.filter((p) => p.gender === setterToMove.gender)
        : nonSettersTeamB;

      if (validCandidates.length > 0) {
        const setterScore = getPlayerPoints(setterToMove);
        const bestMatch = [...validCandidates].sort((a, b) => Math.abs(getPlayerPoints(a) - setterScore) - Math.abs(getPlayerPoints(b) - setterScore))[0];
        playerToSwapFromA = setterToMove;
        playerToSwapFromB = bestMatch;
      }
    } else if (teamBSetters.length >= 2 && teamASetters.length === 0) {
      const setterToMove = teamBSetters[teamBSetters.length - 1];
      const nonSettersTeamA = originalTeamA.filter((p) => p.playerType !== 'Setter');
      const validCandidates = genderBalanceMode
        ? nonSettersTeamA.filter((p) => p.gender === setterToMove.gender)
        : nonSettersTeamA;

      if (validCandidates.length > 0) {
        const setterScore = getPlayerPoints(setterToMove);
        const bestMatch = [...validCandidates].sort((a, b) => Math.abs(getPlayerPoints(a) - setterScore) - Math.abs(getPlayerPoints(b) - setterScore))[0];
        playerToSwapFromA = bestMatch;
        playerToSwapFromB = setterToMove;
      }
    } else {
      let smallestDifference = Infinity;

      originalTeamA.forEach((playerA) => {
        originalTeamB.forEach((playerB) => {
          if (genderBalanceMode && playerA.gender !== playerB.gender) return;

          const newTeamASetters = teamASetters.filter((p) => p.playerId !== playerA.playerId).length + (playerB.playerType === 'Setter' ? 1 : 0);
          const newTeamBSetters = teamBSetters.filter((p) => p.playerId !== playerB.playerId).length + (playerA.playerType === 'Setter' ? 1 : 0);

          if (teamASetters.length === 1 && playerA.playerType === 'Setter' && newTeamASetters === 0) return;
          if (teamBSetters.length === 1 && playerB.playerType === 'Setter' && newTeamBSetters === 0) return;

          if (setterRestrictedMode && totalSetters >= 2) {
            if (newTeamASetters === 0 || newTeamBSetters === 0) return;
          }

          const newTeamAScore = teamAScore - getPlayerPoints(playerA) + getPlayerPoints(playerB);
          const newTeamBScore = teamBScore - getPlayerPoints(playerB) + getPlayerPoints(playerA);

          let scoreDifference;
          if (isOddFemales && genderBalanceMode && teamAFemales > teamBFemales) {
            scoreDifference = Math.abs(newTeamAScore - newTeamBScore * 1.1);
          } else if (isOddFemales && genderBalanceMode && teamBFemales > teamAFemales) {
            scoreDifference = Math.abs(newTeamBScore - newTeamAScore * 1.1);
          } else {
            scoreDifference = Math.abs(newTeamAScore - newTeamBScore);
          }

          if (scoreDifference < smallestDifference) {
            smallestDifference = scoreDifference;
            playerToSwapFromA = playerA;
            playerToSwapFromB = playerB;
          }
        });
      });
    }

    if (playerToSwapFromA && playerToSwapFromB) {
      handlePlayerChangeTeam(playerToSwapFromA.playerId, playerToSwapFromB.playerId);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Button variant="contained" onClick={swapPlayers} size="small">
        Trocar 1 jogador de cada time
      </Button>
    </Box>
  );
}
